






























































import { Component, Vue, Watch } from 'vue-property-decorator';
import ModalAction from '@/components/base/ModalAction.vue';
import { BffSettings } from '@/api/bff';
import { Models } from '@mtap-smartcity/api';

type DeviceTab = 'lamp' | 'gateway';
/*eslint-disable*/
@Component({
  components: {
    ModalAction
  }
})
export default class DeviceFieldsTab extends Vue {

  selectedTab: DeviceTab = 'lamp';

  dialog = false;

  deleteData: { field: Models.Devices.DeviceDetailField; index: number } | null = null;

  editingField: { index: number; originalField: Models.Devices.DeviceDetailField } | null = null;

  fieldKey = 0;

  loading = false;

  error: string | null = null;

  lampFields: Models.Devices.DeviceDetailField[] = [];

  gatewayFields: Models.Devices.DeviceDetailField[] = [];

  get tabs() {
    return [
      { name: this.$tc('main.lamp', 2), value: 'lamp' },
      { name: this.$tc('main.gateway', 2), value: 'gateway' },
    ];
  }

  get currentFields() {
    return this.selectedTab === 'lamp' ? this.lampFields : this.gatewayFields;
  }

  updateSelectedTab(newTab: DeviceTab) {
    this.selectedTab = newTab;
  }

  @Watch('selectedTab')
  async onTabChange() {
    await this.fetchFields();
  }

  async fetchFields() {
    try {
      this.loading = true;
      this.error = null;

      const fields = await BffSettings.getDeviceDetailsSettings(this.selectedTab);

      if (this.selectedTab === 'lamp') {
        this.lampFields = fields;
      } else {
        this.gatewayFields = fields;
      }
    } catch (err) {
      this.error = err instanceof Error ? err.message : 'Failed to load fields';
      console.error('Failed to fetch device details:', err);
    } finally {
      this.loading = false;
    }
  }

  // Existing methods with API integration
  isEditingField(index: number) {
    return this.editingField?.index === index;
  }

  getFieldName(field: Models.Devices.DeviceDetailField, index: number) {
    if (this.editingField?.index === index) {
      return this.editingField.originalField.name;
    }
    return field.name;
  }

  updateFieldName(newName: string, index: number) {
    if (this.editingField) {
      this.editingField.originalField.name = newName;
    }
  }

  eventHandlers(field: Models.Devices.DeviceDetailField, index: number) {
    return {
      select: () => { },
      edit: () => this.editField(field, index),
      discard: () => this.discardEdit(),
      save: () => this.saveField(),
      modalAction: () => {
        this.dialog = true;
        this.deleteData = { field, index };
      }
    };
  }

  editField(field: Models.Devices.DeviceDetailField, index: number) {
    if (!field.name.startsWith('New Field')) { // Don't allow editing placeholder fields
      this.editingField = {
        index,
        originalField: { ...field }
      };
    }
  }

  isDuplicateName(name: string, fields: Models.Devices.DeviceDetailField[], excludeIndex: number): boolean {
    return fields.some((field, index) => index !== excludeIndex && field.name.toLocaleLowerCase() === name.toLocaleLowerCase());
  }

  async saveField() {
    if (!this.editingField) return;

    const targetArray = this.selectedTab === 'lamp' ? this.lampFields : this.gatewayFields;
    const field = this.editingField.originalField;

    if (this.isDuplicateName(field.name, targetArray, this.editingField.index)) {
      window.alert(this.$tc('settings.fieldAlreadyExists'));
      return;
    }

    try {
      // Only send to API if field has been renamed (not a placeholder)
      if (!field.name.startsWith('New Field')) {
        await BffSettings.addDeviceDetailsField(this.selectedTab, field);
        await this.fetchFields(); // Refresh from server
      } else {
        // Remove the unsaved placeholder
        targetArray.splice(this.editingField.index, 1);
      }
      this.editingField = null;
      this.fieldKey++;
    } catch (err) {
      console.error('Failed to save field:', err);
    }
  }

  discardEdit() {
    if (!this.editingField) return;

    const targetArray = this.selectedTab === 'lamp' ? this.lampFields : this.gatewayFields;

    // If discarding a placeholder, remove it completely
    if (this.editingField.originalField.name.startsWith('New Field')) {
      targetArray.splice(this.editingField.index, 1);
    }

    this.editingField = null;
    this.fieldKey++;
  }

  addField() {
    const newField: Models.Devices.DeviceDetailField = {
      name: `New Field ${this.currentFields.length + 1}`,
      type: 'text',
      deprecated: false,
      renamed_to: null
    };

    const targetArray = this.selectedTab === 'lamp' ? this.lampFields : this.gatewayFields;
    const newIndex = targetArray.length;
    targetArray.push(newField);

    // Immediately start editing the new placeholder field (like devices do)
    this.editingField = {
      index: newIndex,
      originalField: { ...newField }
    };
    this.fieldKey++;
  }

  async closeModal() {
    this.dialog = false;
    this.deleteData = null;
  }

  async deleteModal() {
    if (this.deleteData) {
      try {
        await BffSettings.removeDeviceDetailsField(
          this.selectedTab,
          this.deleteData.field.name
        );
        await this.fetchFields(); // Refresh from server
      } catch (err) {
        console.error('Failed to delete field:', err);
        // Handle error
      }
    }
    this.closeModal();
  }

// Initialize data on mount
  async mounted() {
    await this.fetchFields();
  }
}
